















































































import { Component, Mixins } from 'vue-property-decorator';
import { Actions } from '@/ts/store/Constants';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import SelectedItems from '@/components/Admin/Layout/SelectedItems.vue';

@Component({
    components: {
        SelectedItems,
    },
})
export default class AddRoleForm extends Mixins(InputFieldMethods) {
    public roleName: any = '';
    public roleKey: any = '';
    public roleDescription: any = '';
    public roleIsStaff: boolean = true;
    public roleVisible: boolean = true;

    constructor() {
        super();
    }

    public createRole() {
        this.$validator.validate().then((valid) => {
            if (valid) {

                this.$store.dispatch(Actions.ADD_NEW_ROLE, {
                    name: this.roleName,
                    description: this.roleDescription,
                    key: this.roleKey,
                    staff: this.roleIsStaff,
                    visible: this.roleVisible,

                });
            }
        });
    }

    public generateRoleKey() {
        this.roleKey = this.roleName.trim().replaceAll(' ', '-').toLowerCase();
    }

    public cancel() {
        this.$store.dispatch(Actions.HIDE_FORM);
    }
}
